import { useTranslation } from 'react-i18next';
import { FunctionComponent, useEffect, useState } from "react";
import { Layout, Tabs, TabsProps } from "antd";
import PageHeader from "../../../components/page-header/PageHeader";
// import { DetailContent } from "../components/detail-content/DetailContent";
import "../styles.scss";
import { useLocation } from "react-router-dom";
import { routesConfig } from "../../../config/routes";
import CertificateTemplate from "../certificate-template";
import CertificateSetting from "../certificate-setting";
import { getDetailCertificate } from "../../../service/certificate";

const { Content } = Layout;
const imgPath = "/images/";

const DetailCertificate: FunctionComponent = () => {
  const { t } = useTranslation();
  const location = useLocation();

  const [tabNavigate, setTabNavigate] = useState("1");
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [refreshData, setRefreshData] = useState<boolean>(false);

  const currentUrl = window.location.href;
  const url = new URL(currentUrl);
  const pathname = url.pathname;
  const segments = pathname.split("/");
  const lastSegment = segments[segments.length - 1];
  const [nameCertificate, setNameCertificate] = useState("");

  const navigateState = location.state;

  const [tab, setTab] = useState(navigateState.tab||"1");

  const getDetailData = async () => {
    await getDetailCertificate(lastSegment).then((res) => {
      setNameCertificate(res.data.data.name);
    });
  };

  useEffect(() => {
    if (navigateState.tab) {
      setTab(navigateState.tab);
    }
  }, [navigateState]);

  useEffect(() => {
    getDetailData();
  }, []);

  const items: TabsProps["items"] = [
    {
      key: "1",
      label: t("Giới thiệu chung", "Giới thiệu chung"),
      children: (
        <div className="">
          <section className="detail-account detail-course">
            <div className="form-detail">
              <CertificateTemplate tab={lastSegment} />
            </div>
          </section>
        </div>
      ),
    },
    {
      key: "2",
      label: t("Cài đặt hoạt động", "Cài đặt hoạt động"),
      children: (
        <div className="">
          <section className="detail-account detail-course">
            <div className="form-detail-setting">
              <CertificateSetting setNameCertificate={setNameCertificate} />
            </div>
          </section>
        </div>
      ),
    },
  ];

  const listBreadcrumb = [
    {
      title: (
        <a href={`${routesConfig.certificate}`}>{t("Thiết lập mẫu chứng nhận/chứng chỉ", "Thiết lập mẫu chứng nhận/chứng chỉ")}</a>
      ),
    },
    {
      title: nameCertificate,
    },
  ];

  return (
    <>
      <Content className="detail-portal-administration">
        <PageHeader
          title={nameCertificate}
          listBreadcrumb={listBreadcrumb}
          arrowLeft={imgPath + "arrowLeft.svg"}
          positionItem="column"
          breadcrumb={true}
          headerGroupButton={tab === "4"}
        />
        <div className="tabs-heading">
          <Tabs defaultActiveKey={tab} items={items} onChange={setTab} />
        </div>
      </Content>
    </>
  );
};

export default DetailCertificate;
